<fieldset class="panel">
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css">
  <div class="text-center">
    <span class="situacao">Evolução do Dia - {{ marcacaoAtual.data_Comparecimento | date: 'dd/MM/yyyy' }} {{
      marcacaoAtual.isTravada ? 'Travada' : '' }}</span>
    <button class="btn btn-sm btn-primary mr-5" (click)="imprimir()">Imprimir</button>
    <button class="btn btn-sm btn-primary mr-5" (click)="copiarEvolucao()"
      [disabled]="marcacaoAtual.status_Atendimento !== 7 && marcacaoAtual.status_Atendimento !== 6" 
      title="Copia o Relatório Profissional deste atendimento.">
      <i class="fa fa-clipboard"></i> Copiar
    </button>
    <button class="btn btn-sm btn-primary mr-5" (click)="colarEvolucao()"
      [disabled]="!evolucaoCopiada || marcacaoAtual.status_Atendimento !== 5"
      title="Cola a evolução copiada da última consulta FINALIZADA.">
      <i class="fa fa-paste"></i> Colar
    </button>
  </div>
  <div class="toolbar mb-2 d-flex align-items-center gap-1" title="Negrito">
    <button type="button" class="btn btn-sm btn-light" (click)="format('bold')">
      <b>N</b>
    </button>

    <button type="button" class="btn btn-sm btn-light" title="Itálico" (click)="format('italic')">
      <i>I</i>
    </button>

    <button type="button" class="btn btn-sm btn-light" title="Sublinhado" (click)="format('underline')">
      <u>S</u>
    </button>

    <!-- Cor da fonte -->
    <label class="btn btn-sm btn-light color-btn" title="Cor da Fonte">
      <i class="bi bi-palette"></i>
      <input type="color" (click)="salvarSelecao()" (change)="setColor($event)" />
    </label>

    <!-- Cor de fundo -->
    <label class="btn btn-sm btn-light color-btn" title="Cor de Fundo">
      <i class="bi bi-brush-fill"></i>
      <input type="color" (click)="salvarSelecao()" (change)="setBackground($event)" />
    </label>
  </div>

  <div #editorArea class="form-control input-demarcado editor-area" [attr.contenteditable]="!marcacaoAtual.isTravada"
    [innerHTML]="relatorio_Profissional_SafeHtml" [(contenteditableModel)]="marcacaoAtual.relatorio_Profissional">
  </div>

</fieldset>